export default __webpack_public_path__ + "static/assets/eede4a0ffca8f0db3be43d97e156a5f2.png";